module.exports = __webpack_public_path__ + "img/phone.f80dfb53.svg";